import React from "react";
import styles from "./BetTableBaccarat29.module.css";

const BetTableBaccarat29 = ({ data = [], onBetClick, exposures = {} }) => {
  // Helper to normalize string for matching
  const normalizeString = (str) => {
    if (!str) return "";
    return str.replace(/\s+/g, ' ').trim().toLowerCase();
  };

  // Helper to get exposure value
  const getExposureForSelection = (selection, betType = "back") => {
    if (!selection) return 0;

    // Try exposures map
    const keys = [
      selection,
      `${selection} ${betType}`,
      `${selection} ${betType.toUpperCase()}`,
      normalizeString(selection),
    ];

    for (const key of keys) {
      if (key && exposures[key] !== undefined && exposures[key] !== null) {
        const expValue = parseFloat(exposures[key]);
        if (!isNaN(expValue) && expValue !== 0) {
          return expValue;
        }
      }
    }

    return 0;
  };

  // Get data items for Player A and Player B
  const getPlayerData = (player, subtype) => {
    return data.find(item =>
      item.nat === player && item.subtype === subtype
    ) || {};
  };

  // Get Lucky 9 data
  const getLucky9Data = () => {
    return data.find(item => item.subtype === "lucky9") || {};
  };

  const isLocked = (value, betData) => {
    return value === 0 || value === undefined || betData?.gstatus?.toUpperCase() === "SUSPENDED";
  };

  // Render odds cell for Player A/B table
  const renderOddsCell = (item, label) => {
    const value = item?.b ?? 0;
    const locked = isLocked(value, item);
    const exposure = getExposureForSelection(label, "back");
    const displayExposure = exposure !== 0 ? (exposure < 0 ? exposure.toFixed(0) : `+${exposure.toFixed(0)}`) : "0";

    return (
      <td className={`box-1 back text-center ${locked ? "suspended" : ""}`} style={{ backgroundColor: locked ? 'transparent' : '#72bbef' }}>
        <span className="odds">
          {!locked && <b>{value || 0}</b>}
        </span>
        <span style={{ display: 'block', color: 'black', fontSize: '12px' }}>{displayExposure}</span>
      </td>
    );
  };

  // Get Player A data
  const playerAWinner = getPlayerData("Player A", "teensin");
  const playerAHighCard = getPlayerData("High Card A", "highcard");
  const playerAPair = getPlayerData("Pair A", "pair");
  const playerAColorPlus = getPlayerData("Color Plus A", "colorplus");

  // Get Player B data
  const playerBWinner = getPlayerData("Player B", "teensin");
  const playerBHighCard = getPlayerData("High Card B", "highcard");
  const playerBPair = getPlayerData("Pair B", "pair");
  const playerBColorPlus = getPlayerData("Color Plus B", "colorplus");

  // Get Lucky 9 data
  const lucky9Data = getLucky9Data();
  const lucky9Back = lucky9Data?.b || 0;
  const lucky9Lay = lucky9Data?.l || 0;
  const isLucky9BackLocked = isLocked(lucky9Back, lucky9Data);
  const isLucky9LayLocked = isLocked(lucky9Lay, lucky9Data);
  const lucky9Exposure = getExposureForSelection(lucky9Data?.nat || "Lucky 9", "back");
  const displayLucky9Exposure = lucky9Exposure !== 0 ? (lucky9Exposure < 0 ? lucky9Exposure.toFixed(0) : `+${lucky9Exposure.toFixed(0)}`) : "0";

  // Get min/max from first item (all should have same min/max)
  const minValue = data[0]?.min || "100";
  const maxValue = data[0]?.max || "500K";

  return (
    <div>
      {/* Player A/B Table */}
      <div className="table-responsive m-t-10 casino-box">
        <table className="table table-bordered m-b-0">
          <thead>
            <tr>
              <th className="box-6"></th>
              <th style={{ fontSize: '10px', backgroundColor: '#72bbef', color:'black' }} className="box-1 text-center back">Winner</th>
              <th style={{ fontSize: '10px', backgroundColor: '#72bbef', color:'black' }} className="box-1 text-center back">High</th>
              <th style={{ fontSize: '10px', backgroundColor: '#72bbef', color:'black' }} className="box-1 text-center back">Pair</th>
              <th style={{ fontSize: '10px', backgroundColor: '#72bbef', color:'black' }} className="box-1 text-center back">Color Plus</th>
              <th className="box-2"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="box-6" style={{ backgroundColor: '#333d79ff', color: 'white' }}>
                <b>Player A</b>
                <p className="m-b-0"></p>
              </td>
              {renderOddsCell(playerAWinner, "Player A")}
              {renderOddsCell(playerAHighCard, "High Card A")}
              {renderOddsCell(playerAPair, "Pair A")}
              {renderOddsCell(playerAColorPlus, "Color Plus A")}
              <td className="text-right box-2" style={{ backgroundColor: '#333d79ff', color: 'white' }}>
                Min:<span>{minValue}</span>
                <br />
                Max:<span>{maxValue}</span>
              </td>
            </tr>
            <tr>
              <td className="box-6" style={{ backgroundColor: '#333d79ff', color: 'white' }}>
                <b>Player B</b>
              </td>
              {renderOddsCell(playerBWinner, "Player B")}
              {renderOddsCell(playerBHighCard, "High Card B")}
              {renderOddsCell(playerBPair, "Pair B")}
              {renderOddsCell(playerBColorPlus, "Color Plus B")}
              <td className="text-right box-2" style={{ backgroundColor: '#333d79ff', color: 'white' }}>
                Min:<span>{minValue}</span>
                <br />
                Max:<span>{maxValue}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Lucky 9 Table */}
      <div className="table-responsive m-t-10 casino-box">
        <table className="table table-bordered m-b-0">
          <thead>
            <tr>
              <th className="box-6"></th>
              <th style={{ fontSize: '10px', backgroundColor: '#72bbef' }} className="box-2 text-center back">Back</th>
              <th style={{ fontSize: '10px', backgroundColor: '#faa9ba' }} className="box-2 text-center lay">Lay</th>
              <th className="box-1"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="box-6" style={{ backgroundColor: '#333d79ff', color: 'white' }}>
                <b>Lucky 9</b>
                <p className="m-b-0"></p>
              </td>
              <td className={`box-1 back text-center ${isLucky9BackLocked ? "suspended" : ""}`} style={{ backgroundColor: isLucky9BackLocked ? 'transparent' : '#72bbef' }}>
                <span className="odds">
                  {!isLucky9BackLocked && <b>{lucky9Back || 0}</b>}
                </span>
              </td>
              <td className={`box-1 lay text-center ${isLucky9LayLocked ? "suspended" : ""}`} style={{ backgroundColor: isLucky9LayLocked ? 'transparent' : '#faa9ba' }}>
                <span className="odds">
                  {!isLucky9LayLocked && <b>{lucky9Lay || 0}</b>}
                </span>
              </td>
              <td className="text-right box-2" style={{ backgroundColor: '#333d79ff', color: 'white' }}>
                Min:<span>{minValue}</span>
                <br />
                Max:<span>{maxValue}</span>
              </td>
            </tr>
            <tr>
              <td></td>
              <td colSpan="2" className="text-center" style={{ backgroundColor: '#333d79ff', color: 'white' }}>
                <span style={{ color: 'white' }}>{displayLucky9Exposure}</span>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BetTableBaccarat29;


